package pl.michal_cyran.portfolio.projects.domain


data class Screenshot(
    val resource: String,
    val label: String,
)